import actionTypes from '../actionTypes';

const initialState = {
    domain: process.env.REACT_APP_DOMAIN
}

const domain = (state = initialState, action) => {
    if (action.type === actionTypes.SET_DOMAIN) {
        return {
            domain: action.payload
        }
    }
    return state;

};

export default domain;
